import React from 'react'
import { Table } from '../../components'
import { checkNegative, STRING } from 'helpers'
import NumberFormat from 'react-number-format'

export class FinancialStatementTable extends React.Component {
  render() {
    const { info } = this.props
    return info && info.length ? (
      <Table className="theme-blue financial-statement financial-score">
        <Table.THEAD>
          <Table.TR className="header">
            <Table.TH className="detail-list"></Table.TH>

            <Table.TH colSpan="2">{info[0].FISCAL_YEAR - 543}</Table.TH>

            <Table.TH colSpan="2">{info[1].FISCAL_YEAR - 543}</Table.TH>

            <Table.TH colSpan="2">{info[2].FISCAL_YEAR - 543}</Table.TH>
          </Table.TR>

          <Table.TR className="sub-header">
            <Table.TD className="detail-list">
              {STRING.STATEMENT_OF_FINANCIAL}
            </Table.TD>

            <Table.TD className={`year-detail`}>
              {STRING.AMOUNT} <br />({STRING.THB})
            </Table.TD>

            <Table.TD className={`year-detail`}>
              {STRING.CHANGE_RATE} <br />
              (%)
            </Table.TD>

            <Table.TD className={`year-detail`}>
              {STRING.AMOUNT} <br />({STRING.THB})
            </Table.TD>

            <Table.TD className={`year-detail`}>
              {STRING.CHANGE_RATE} <br />
              (%)
            </Table.TD>

            <Table.TD className={`year-detail`}>
              {STRING.AMOUNT} <br />({STRING.THB})
            </Table.TD>

            <Table.TD className={`year-detail`}>
              {STRING.CHANGE_RATE} <br />
              (%)
            </Table.TD>
          </Table.TR>
        </Table.THEAD>

        <Table.TBODY>
          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.ACCOUNTS_RECEIVABLE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS01)}`}
            >
              {info[0].BAL_BS01 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS01}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS01_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS01_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS01)}`}
            >
              {info[1].BAL_BS01 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS01}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS01_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS01_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS01)}`}
            >
              {info[2].BAL_BS01 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS01}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS01_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS01_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.INVENTORIES}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS02)}`}
            >
              {info[0].BAL_BS02 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS02}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS02_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS02_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS02)}`}
            >
              {info[1].BAL_BS02 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS02}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS02_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS02_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS02)}`}
            >
              {info[2].BAL_BS02 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS02}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS02_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS02_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.TOTAL_CURRENT_ASSETS}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS03)}`}
            >
              {info[0].BAL_BS03 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS03}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS03_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS03_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS03)}`}
            >
              {info[1].BAL_BS03 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS03}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS03_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS03_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS03)}`}
            >
              {info[2].BAL_BS03 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS03}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS03_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS03_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.PROPERTY_PLANT}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS10)}`}
            >
              {info[0].BAL_BS10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS10_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS10_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS10)}`}
            >
              {info[1].BAL_BS10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS10_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS10_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS10)}`}
            >
              {info[2].BAL_BS10 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS10}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS10_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS10_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.TOTAL_NONCURRENT}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS19)}`}
            >
              {info[0].BAL_BS19 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS19}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS19_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS19_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS19)}`}
            >
              {info[1].BAL_BS19 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS19}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS19_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS19_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS19)}`}
            >
              {info[2].BAL_BS19 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS19}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS19_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS19_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.TOTAL_ASSETS}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS99)}`}
            >
              {info[0].BAL_BS99 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS99}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS99_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS99_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS99)}`}
            >
              {info[1].BAL_BS99 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS99}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS99_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS99_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS99)}`}
            >
              {info[2].BAL_BS99 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS99}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS99_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS99_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.TOTAL_CURRENT_LIABILITIES}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS15)}`}
            >
              {info[0].BAL_BS15 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS15}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS15_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS15_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS15)}`}
            >
              {info[1].BAL_BS15 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS15}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS15_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS15_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS15)}`}
            >
              {info[2].BAL_BS15 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS15}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS15_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS15_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.TOTAL_NONCURRENT_LIABILITIES}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS36)}`}
            >
              {info[0].BAL_BS36 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS36}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS36_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS36_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS36)}`}
            >
              {info[1].BAL_BS36 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS36}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS36_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS36_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS36)}`}
            >
              {info[2].BAL_BS36 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS36}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS36_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS36_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.TOTAL_LIABILITIES}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS22)}`}
            >
              {info[0].BAL_BS22 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS22}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS22_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS22_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS22)}`}
            >
              {info[1].BAL_BS22 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS22}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS22_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS22_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS22)}`}
            >
              {info[2].BAL_BS22 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS22}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS22_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS22_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">{STRING.EQUITY}</Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS23)}`}
            >
              {info[0].BAL_BS23 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS23}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS23_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS23_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS23)}`}
            >
              {info[1].BAL_BS23 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS23}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS23_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS23_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS23)}`}
            >
              {info[2].BAL_BS23 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS23}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS23_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS23_CHANGE_RATE}
            </Table.TD>
          </Table.TR>

          <Table.TR>
            <Table.TD className="detail-list">
              {STRING.TOTAL_LIABILITIES_EQUITY}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[0].BAL_BS99)}`}
            >
              {info[0].BAL_BS99 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[0].BAL_BS99}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[0].BAL_BS99_CHANGE_RATE
              )}`}
            >
              {info[0].BAL_BS99_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[1].BAL_BS99)}`}
            >
              {info[1].BAL_BS99 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[1].BAL_BS99}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[1].BAL_BS99_CHANGE_RATE
              )}`}
            >
              {info[1].BAL_BS99_CHANGE_RATE}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(info[2].BAL_BS99)}`}
            >
              {info[2].BAL_BS99 == 'N/A' ? (
                'N/A'
              ) : (
                <NumberFormat
                  value={info[2].BAL_BS99}
                  displayType={'text'}
                  thousandSeparator={true}
                />
              )}
            </Table.TD>

            <Table.TD
              className={`year-detail ${checkNegative(
                info[2].BAL_BS99_CHANGE_RATE
              )}`}
            >
              {info[2].BAL_BS99_CHANGE_RATE}
            </Table.TD>
          </Table.TR>
        </Table.TBODY>
      </Table>
    ) : null
  }
}
